module.exports = __webpack_public_path__ + "static/asignin-8b7db8204af6695cb78f359111d5099b.png";